import React from "react";
import { useLocation, useNavigate } from "react-router";
import backButtonIcon from "../../assets/images/back-button.png";

const sectionTitleClass = "font-oswald text-[20px] font-bold text-white pt-5";
const paragraphClass =
  "font-oswald text-[16px] font-normal leading-6 text-white/90";
const bulletListClass = "list-disc pl-8";
const bulletItemClass =
  "font-oswald text-[16px] font-normal leading-6 text-white/90";

export const TermsOfUse: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const shouldHideHeader =
    new URLSearchParams(location.search).get("hideHeader") === "1";

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/auth");
  };

  const content = (
    <div className="mx-auto flex w-full max-w-4xl flex-1 overflow-y-auto px-4 pb-10">
      <div className="w-full space-y-5 text-left">
        <h1 className="font-oswald text-[22px] font-normal text-white text-center py-4">
          Terms of Use - XConfessions App
        </h1>

        <p className={paragraphClass}>Effective date: March 19, 2026</p>

        <p className={paragraphClass}>
          These Terms of Use (&quot;Terms&quot;) govern access to and use of the
          XConfessions mobile application and related services (the
          &quot;App&quot; or &quot;Service&quot;).
        </p>
        <p className={paragraphClass}>
          The Service is operated by LUST PRODUCTIONS, S.L. (hereinafter
          &quot;LUST&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;),
          holder of CIF B-63521165, with registered address at C/ Diputació 185,
          Ppal 2, 08011 Barcelona, Spain.
        </p>
        <p className={paragraphClass}>
          By accessing or using the App, you agree to be bound by these Terms.
          If you do not agree, you must not use the Service.
        </p>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>1. Eligibility</h2>
          <p className={paragraphClass}>
            The App is intended strictly for adults.
          </p>
          <p className={paragraphClass}>
            By using the Service, you confirm that:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              You are at least 18 years old or the legal age of majority in your
              jurisdiction
            </li>
            <li className={bulletItemClass}>
              You are legally allowed to access adult content in your
              jurisdiction
            </li>
            <li className={bulletItemClass}>
              All information you provide is accurate and truthful
            </li>
          </ul>
          <p className={paragraphClass}>
            We may implement age verification or age assurance mechanisms where
            required by law and reserve the right to restrict access
            accordingly.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>2. Description of the Service</h2>
          <p className={paragraphClass}>
            XConfessions is a digital platform that allows consenting adults to
            explore, share, and match sexual fantasies with partner(s) in a
            private environment.
          </p>
          <p className={paragraphClass}>The Service may include:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>Matching features</li>
            <li className={bulletItemClass}>
              Interactive cards or swiping mechanisms
            </li>
            <li className={bulletItemClass}>Premium features</li>
            <li className={bulletItemClass}>
              Other functionalities introduced over time
            </li>
          </ul>
          <p className={paragraphClass}>
            We may modify, add, or remove features at any time without prior
            notice.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>3. User Accounts</h2>
          <p className={paragraphClass}>
            Users may create accounts to access certain features.
          </p>
          <p className={paragraphClass}>You agree to:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              Provide accurate and current information
            </li>
            <li className={bulletItemClass}>
              Keep your login credentials confidential
            </li>
            <li className={bulletItemClass}>
              Be responsible for all activity under your account
            </li>
          </ul>
          <p className={paragraphClass}>You may not:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>Share your account</li>
            <li className={bulletItemClass}>Impersonate others</li>
            <li className={bulletItemClass}>Use the Service fraudulently</li>
          </ul>
          <p className={paragraphClass}>
            We may suspend or terminate accounts that violate these Terms.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>4. In-App Purchases</h2>
          <p className={paragraphClass}>
            The App may offer paid features and in-app purchases (&quot;Premium
            Features&quot;).
          </p>
          <p className={paragraphClass}>These may include:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              Additional interactions (e.g., extra swipes)
            </li>
            <li className={bulletItemClass}>Enhanced matching capabilities</li>
            <li className={bulletItemClass}>Other premium functionalities</li>
          </ul>
          <p className={paragraphClass}>Important conditions:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>All purchases are optional</li>
            <li className={bulletItemClass}>
              Prices and availability may change at any time
            </li>
            <li className={bulletItemClass}>
              Payments are processed via third-party platforms (e.g., Apple App
              Store, Google Play), whose terms also apply
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>5. Subscriptions</h2>
          <p className={paragraphClass}>
            At this time, the App does not offer subscription plans.
          </p>
          <p className={paragraphClass}>
            If subscriptions are introduced in the future, additional terms may
            apply.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>6. Cancellation Policy</h2>
          <p className={paragraphClass}>
            For one-time purchases of Premium Features, users may stop using the
            purchased feature at any time, but completed purchases cannot be
            cancelled once processed.
          </p>
          <p className={paragraphClass}>
            If the App offers consumable digital items (such as credits, tokens,
            or similar features), these are deemed used once applied or redeemed
            within the Service and cannot be cancelled or reversed.
          </p>
          <p className={paragraphClass}>
            If subscription plans are introduced in the future, users will be
            able to manage or cancel subscriptions through the app or payment
            provider settings.
          </p>
          <p className={paragraphClass}>
            Deleting the App or an account does not automatically cancel active
            subscriptions managed through a third-party payment platform.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>7. Refund Policy</h2>
          <p className={paragraphClass}>
            Except where required by applicable law, all purchases of digital
            goods and Premium Features are final and non-refundable.
          </p>
          <p className={paragraphClass}>
            Refund requests, where applicable, are handled by the relevant
            payment platform (such as the Apple App Store, Google Play, or other
            authorized payment providers) in accordance with their respective
            policies.
          </p>
          <p className={paragraphClass}>
            By purchasing digital content or Premium Features, you expressly
            consent to the immediate provision of the digital service and
            acknowledge that, to the extent permitted by applicable law, you may
            lose any statutory right of withdrawal once the service has begun.
          </p>
          <p className={paragraphClass}>
            Nothing in these Terms limits any mandatory consumer rights
            applicable under local law.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>8. Acceptable Use</h2>
          <p className={paragraphClass}>
            You agree to use the Service responsibly.
          </p>
          <p className={paragraphClass}>You must not:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>Harass or abuse other users</li>
            <li className={bulletItemClass}>
              Share illegal or non-consensual content
            </li>
            <li className={bulletItemClass}>
              Promote violence, coercion, or exploitation
            </li>
            <li className={bulletItemClass}>
              Attempt to hack, disrupt, or reverse engineer the Service
            </li>
            <li className={bulletItemClass}>
              Use the App for spam or commercial solicitation
            </li>
          </ul>
          <p className={paragraphClass}>
            We may remove content or suspend accounts at our discretion.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>9. Privacy</h2>
          <p className={paragraphClass}>
            Your use of the App is governed by our Privacy Policy, which
            explains how we collect and process personal data.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>10. Intellectual Property</h2>
          <p className={paragraphClass}>
            All content and materials in the App, including:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>Software</li>
            <li className={bulletItemClass}>Design and UI</li>
            <li className={bulletItemClass}>Logos and trademarks</li>
            <li className={bulletItemClass}>
              Text, audiovisual, and other content
            </li>
          </ul>
          <p className={paragraphClass}>
            are the exclusive property of LUST or its licensors and are
            protected by applicable intellectual property laws.
          </p>
          <p className={paragraphClass}>You may not:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              Copy, reproduce, distribute, or modify any part of the Service
            </li>
            <li className={bulletItemClass}>
              Use our trademarks without prior written consent
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>11. Feedback</h2>
          <p className={paragraphClass}>
            If you provide suggestions, ideas, or feedback regarding the
            Service:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              You grant LUST the right to use such feedback freely
            </li>
            <li className={bulletItemClass}>
              No compensation or credit is owed to you
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>12. License to Use the App</h2>
          <p className={paragraphClass}>
            We grant you a limited, non-exclusive, non-transferable, revocable
            license to use the App for personal, non-commercial purposes.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>13. Disclaimer of Warranties</h2>
          <p className={paragraphClass}>
            The Service is provided &quot;as is&quot; and &quot;as
            available&quot;.
          </p>
          <p className={paragraphClass}>
            We disclaim all warranties, including:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>Merchantability</li>
            <li className={bulletItemClass}>
              Fitness for a particular purpose
            </li>
            <li className={bulletItemClass}>Non-infringement</li>
            <li className={bulletItemClass}>
              Error-free or uninterrupted operation
            </li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>14. Limitation of Liability</h2>
          <p className={paragraphClass}>
            To the fullest extent permitted by law, LUST is not liable for:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>
              Indirect or consequential damages
            </li>
            <li className={bulletItemClass}>Loss of data or profits</li>
            <li className={bulletItemClass}>Service interruptions</li>
            <li className={bulletItemClass}>User interactions or conduct</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>15. Third-Party Services</h2>
          <p className={paragraphClass}>
            The App may rely on third-party services (e.g., app stores, payment
            providers, analytics).
          </p>
          <p className={paragraphClass}>
            These are governed by their own terms, and we are not responsible
            for them.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>16. Suspension or Termination</h2>
          <p className={paragraphClass}>
            We may suspend or terminate access if:
          </p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>You violate these Terms</li>
            <li className={bulletItemClass}>Fraud or misuse is suspected</li>
            <li className={bulletItemClass}>Required by law</li>
          </ul>
          <p className={paragraphClass}>
            You may stop using the Service at any time.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>
            17. Changes to the Terms or Service
          </h2>
          <p className={paragraphClass}>We may update:</p>
          <ul className={bulletListClass}>
            <li className={bulletItemClass}>These Terms</li>
            <li className={bulletItemClass}>Features or functionality</li>
            <li className={bulletItemClass}>Pricing</li>
          </ul>
          <p className={paragraphClass}>
            Changes become effective upon publication. Continued use constitutes
            acceptance.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>
            18. Applicable Law and Jurisdiction
          </h2>
          <p className={paragraphClass}>
            These Terms are governed by the laws of Spain.
          </p>
          <p className={paragraphClass}>
            Any disputes shall be subject to the courts of Barcelona, Spain.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className={sectionTitleClass}>19. Contact</h2>
          <p className={paragraphClass}>
            For any questions regarding these Terms, you may contact us at:
          </p>
          <a
            href="mailto:support@erikalust.com"
            className="font-oswald text-[16px] font-normal text-white underline transition-opacity hover:opacity-80"
          >
            support@erikalust.com
          </a>
        </section>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-dvh flex-col bg-xcf-gradient">
      {!shouldHideHeader && (
        <div className="sticky top-0 z-20 flex h-12 items-center justify-center bg-xcf-gradient-start px-3">
          <div className="relative mx-auto flex h-12 w-full max-w-4xl items-center justify-center">
            <button
              type="button"
              onClick={handleClose}
              className="absolute left-0 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center"
              aria-label="Back"
            >
              <img
                src={backButtonIcon}
                alt="Back"
                className="h-6 w-6 object-contain"
              />
            </button>
            <h1 className="font-oswald text-[18px] font-normal lowercase text-white">
              terms of use
            </h1>
          </div>
        </div>
      )}
      {content}
    </div>
  );
};
